import type { PontoGraficoModel, CategoriaModel } from "../../../services/listarProdutos"

export type { PontoGraficoModel, CategoriaModel }

export type ListarProdutosModel = {
    pontos: PontoGraficoModel[]
    categorias: CategoriaModel[]
    pesquisado: boolean
}

export const ListarProdutosInicial: ListarProdutosModel = {
    pontos: [],
    categorias: [],
    pesquisado: false,
}
